'use client';

import React, { useState, useEffect, Fragment } from "react";
import LayoutDashboard from "../../Components/Layout/LayoutDashboard";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Box from "@material-ui/core/Box";
import MaterialTable from "material-table";
import { Link } from "react-router-dom";
import { Button, Tooltip, Hidden, IconButton, Paper, Chip } from "@material-ui/core";
import ModalImage from "react-modal-image";
import FormatColorFillIcon from "@material-ui/icons/FormatColorFill";
import { green } from "@material-ui/core/colors";
import PictureAsPdf from "@material-ui/icons/PictureAsPdf";
import MoneyOffIcon from "@material-ui/icons/MoneyOff";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";

import fileDownload from "js-file-download";
import clienteAxios from "../../Config/Axios";

/**Importar metodo Get */
import MethodGet, { MethodDelete } from "../../Config/Services";
/**Importar Sweetalert2 * */
import Swal from "sweetalert2";
/**importar spinner */
import Spinner from "../../Complements/Spinner";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(10),
    paddingBottom: theme.spacing(4),
    paddingInlineEnd: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginBlockEnd: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  input: {
    display: "none",
  },
  typography: {
    margin: theme.spacing(0, 1, 2, 2),
  },
  // Header modernizado
  headerCard: {
    background: "linear-gradient(135deg, #3f51b5 0%, #5c6bc0 50%, #4527a0 100%)",
    color: "white",
    borderRadius: "16px",
    padding: theme.spacing(4),
    marginTop: theme.spacing(12),
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    boxShadow: "0 10px 40px rgba(63, 81, 181, 0.3)",
    position: "relative",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      right: 0,
      width: "300px",
      height: "300px",
      background: "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
      borderRadius: "50%",
      transform: "translate(50%, -50%)",
    },
  },
  headerTitle: {
    fontWeight: 700,
    fontSize: "1.75rem",
    letterSpacing: "-0.5px",
    marginBottom: theme.spacing(1),
    position: "relative",
    zIndex: 1,
  },
  headerSubtitle: {
    opacity: 0.9,
    fontSize: "0.95rem",
    fontWeight: 400,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    position: "relative",
    zIndex: 1,
  },
  // Botón flotante mejorado
  fabContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: theme.spacing(4),
    marginTop: theme.spacing(-3),
    position: "relative",
    zIndex: 10,
  },
  fabGreen: {
    color: theme.palette.common.white,
    backgroundColor: green[500],
    width: 56,
    height: 56,
    boxShadow: "0 6px 20px rgba(76, 175, 80, 0.4)",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      backgroundColor: green[600],
      transform: "scale(1.1)",
      boxShadow: "0 8px 25px rgba(76, 175, 80, 0.5)",
    },
  },
  // Contenedor de tablas mejorado
  tableContainer: {
    margin: theme.spacing(3),
    marginTop: theme.spacing(4),
    borderRadius: "16px",
    overflow: "hidden",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
    "& .MuiPaper-root": {
      borderRadius: "16px",
      boxShadow: "none",
    },
    "& .MuiToolbar-root": {
      background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)",
      borderBottom: "1px solid rgba(63, 81, 181, 0.1)",
      minHeight: 70,
    },
    "& .MuiTypography-h6": {
      color: "#3f51b5",
      fontWeight: 600,
      fontSize: "1.1rem",
    },
    "& .MuiTableHead-root": {
      "& .MuiTableCell-head": {
        backgroundColor: "#fafbfc",
        color: "#3f51b5",
        fontWeight: 600,
        fontSize: "0.875rem",
        borderBottom: "2px solid rgba(63, 81, 181, 0.2)",
        padding: theme.spacing(2),
      },
    },
    "& .MuiTableBody-root": {
      "& .MuiTableRow-root": {
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: "rgba(63, 81, 181, 0.04)",
        },
      },
      "& .MuiTableCell-body": {
        padding: theme.spacing(1.5, 2),
        fontSize: "0.875rem",
        color: "#424242",
      },
    },
    "& .MuiTablePagination-root": {
      borderTop: "1px solid rgba(0, 0, 0, 0.08)",
      backgroundColor: "#fafbfc",
    },
  },
  // Botones de acción modernos
  actionButton: {
    minWidth: 40,
    width: 40,
    height: 40,
    borderRadius: "12px",
    margin: theme.spacing(0, 0.5),
    transition: "all 0.2s ease",
    backgroundColor: "white",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
    },
  },
  actionButtonPdf: {
    "&:hover": {
      backgroundColor: "rgba(244, 67, 54, 0.08)",
      borderColor: "rgba(244, 67, 54, 0.3)",
    },
  },
  actionButtonEdit: {
    "&:hover": {
      backgroundColor: "rgba(63, 81, 181, 0.08)",
      borderColor: "rgba(63, 81, 181, 0.3)",
    },
  },
  actionButtonDelete: {
    "&:hover": {
      backgroundColor: "rgba(244, 67, 54, 0.08)",
      borderColor: "rgba(244, 67, 54, 0.3)",
    },
  },
  actionButtonIndigo: {
    "&:hover": {
      backgroundColor: "rgba(75, 0, 130, 0.08)",
      borderColor: "rgba(75, 0, 130, 0.3)",
    },
  },
  // Panel de detalle móvil mejorado
  detailPanel: {
    backgroundColor: "#f8f9fc",
    padding: theme.spacing(3),
    borderLeft: "4px solid #3f51b5",
    margin: theme.spacing(1),
    borderRadius: "0 12px 12px 0",
  },
  detailItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1.5),
    fontSize: "0.9rem",
    color: "#424242",
    "& strong": {
      color: "#3f51b5",
      marginRight: theme.spacing(1),
      minWidth: 100,
    },
  },
  detailActions: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, 0.08)",
  },
  // Tabla móvil
  mobileTableContainer: {
    margin: theme.spacing(2, 1),
    marginTop: theme.spacing(2),
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
    "& .MuiPaper-root": {
      borderRadius: "12px",
      boxShadow: "none",
    },
    "& .MuiToolbar-root": {
      background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)",
      minHeight: 60,
    },
    "& .MuiTypography-h6": {
      color: "#3f51b5",
      fontWeight: 600,
      fontSize: "0.95rem",
    },
  },
  // Sección título
  sectionDivider: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(4, 3, 2, 3),
    "&::before, &::after": {
      content: '""',
      flex: 1,
      borderBottom: "2px solid rgba(63, 81, 181, 0.15)",
    },
  },
  sectionChip: {
    margin: theme.spacing(0, 2),
    backgroundColor: "rgba(63, 81, 181, 0.1)",
    color: "#3f51b5",
    fontWeight: 600,
    padding: theme.spacing(0.5, 1),
  },
}));

export default function ExpensesIndex(props) {
  const classes = useStyles();

  //sucursales = state, guardarBranch =funcion para guardar en el state;
  const [expenses, saveExpenses] = useState([]);
  const [comissions, saveComissions] = useState([]);
  const [cargando, spinnerCargando] = useState(false);
  const { id } = props.match.params; //Se toma el ID de la Sucursal para mostrar sus productos
  const [branch, guardarBranch] = useState({});
  const [error, guardarError] = useState(false);

  //Extraer valores de branch(destructuracion)
  const { name, direction, number_phone, state_id, municipality_id } = branch;

  //query a la api
  useEffect(() => {
    let url = `/sucursalgastos/${id}`;
    MethodGet(url)
      .then((res) => {
        saveExpenses(res.data.expenses);
        saveComissions(res.data.comissions);
        spinnerCargando(true);
      })
      .catch((error) => {
        console.log(error);
        spinnerCargando(true);
      });
  }, []);

  //obtener los campos de la sucursal
  useEffect(() => {
    let url = `/branches/${id}`;
    MethodGet(url)
      .then((res) => {
        guardarBranch(res.data.data);
        spinnerCargando(true);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const generarTicket = (id, folio) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "¿Desea Generar El Ticket De Comisión?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Generar",
      cancelButtonText: "No, Cancelar",
    }).then((result) => {
      if (result.value) {
        let timerInterval;
        Swal.fire({
          title: "Generando",
          html: "El ticket se está generando",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          willClose: () => {
            clearInterval(timerInterval);
          },
        })
        //Cunsume API de Back-end en laravel para generar tiket de venta
        clienteAxios
          .get(`/ticket-comision/${id}`, { responseType: "blob" })
          .then((response) => {
            fileDownload(response.data, "Ticket Comisión Pagada.pdf");
            guardarError(false);
          })
          .catch((error) => {
            if (error.response.status === 409) {
              Swal.fire({
                icon: "error",
                title: "Algo sucedio",
                text: "No se cuenta con suficiente información para generar el reporte",
              });
            } else if (error.response.status === 422) {
              Swal.fire({
                icon: "error",
                title: "Algo sucedio",
                text: "No se pudo generar el reporte",
              });
            }
          });
      }
    });
  };

  const generarTicketCashOut = (id) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "¿Desea Generar El Ticket?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Generar",
      cancelButtonText: "No, Cancelar",
    }).then((result) => {
      if (result.value) {
        let timerInterval;
        Swal.fire({
          title: "Generando",
          html: "El ticket se está generando",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          willClose: () => {
            clearInterval(timerInterval);
          },
        });
        //Consume API de Back-end en laravel para generar ticket de salida de efectivo
        clienteAxios
          .get(`/ticket-expenses/${id}`, { responseType: "blob" })
          .then((response) => {
            // Crear un link temporal para descargar el archivo
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Ticket_Gasto_${id}.pdf`);
            document.body.appendChild(link);
            link.click();

            // Limpieza
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
          })
          .catch((error) => {
            if (error.response && error.response.status === 500) {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "Por Favor, Contacta Con Soporte Técnico",
              });
            } else {
              console.error("Error al descargar el ticket de gasto:", error);
            }
          });
      }
    });
  };

  const eliminarGasto = (id) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "El gasto seleccionado no se podrá recuperar",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Eliminar",
      cancelButtonText: "No, Cancelar",
    }).then((result) => {
      if (result.value) {
        // eliminar en la rest api
        let url = `/expenses/${id}`;
        MethodDelete(url)
          .then((res) => {
            if (res.status === 200) {
              const CambioIndexExpenses = expenses.filter(
                (expense) => expense.id !== id
              );
              saveExpenses(CambioIndexExpenses);
              Swal.fire("Gasto Eliminado", res.data.mensaje, "success");
            }
          })
          .catch((error) => {
            Swal.fire({
              title: "Error",
              text: error.response.data.error,
              icon: "error",
            });
          });
      }
    });
  };

  //  spinner de carga
  if (!cargando) return <Spinner />;

  return (
    <LayoutDashboard>
      {/* Header modernizado */}
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Paper className={classes.headerCard} elevation={0}>
            <Box display="flex" alignItems="center" mb={1}>
              <MoneyOffIcon style={{ fontSize: 32, marginRight: 12, opacity: 0.9 }} />
              <Typography className={classes.headerTitle} component="h1">
                Gastos Realizados por Sucursal {name}
              </Typography>
            </Box>
            <Typography className={classes.headerSubtitle}>
              <AccountBalanceWalletIcon style={{ fontSize: 18 }} />
              Registro y control de gastos operativos
            </Typography>
          </Paper>
        </Grid>

        {/* Botón flotante de agregar */}
        <Grid item xs={12} className={classes.fabContainer}>
          <Tooltip
            title="Agregar Nuevo Gasto"
            aria-label="Agregar Gasto"
            placement="left"
          >
            <Fab
              className={classes.fabGreen}
              aria-label="add"
              href={"/AgregarGasto/" + id}
            >
              <AddIcon style={{ fontSize: 28 }} />
            </Fab>
          </Tooltip>
        </Grid>
      </Grid>

      {/* Tabla de Gastos - Desktop */}
      <Hidden only={["xs", "sm"]}>
        <Box className={classes.tableContainer}>
          <MaterialTable
            title={"Gastos de la Sucursal " + name}
            columns={[
              { title: "Nombre", field: "name" },
              { title: "Descripción", field: "description" },
              { title: "Fecha Realizada", field: "created_at", type: "date" },
              {
                title: "Total",
                field: "total",
                render: (rowData) =>
                  new Intl.NumberFormat("es-MX", {
                    style: "currency",
                    currency: "MXN",
                    minimumFractionDigits: 0,
                  }).format(rowData.total),
              },
              {
                title: "Imagen",
                field: "image",
                render: (rowData) =>
                  rowData.image ? (
                    <ModalImage
                      small={rowData.image}
                      large={rowData.image}
                      alt="Ticket Gasto"
                    />
                  ) : (
                    <ModalImage
                      small={
                        "https://pisouniversitario.com/template/images/page-404.jpg"
                      }
                      large={
                        "https://pisouniversitario.com/template/images/page-404.jpg"
                      }
                      alt="Ticket Gasto"
                    />
                  ),
              },
              { title: "Sucursal", field: "branch_name" },
              { title: "Usuario", field: "username" },
            ]}
            data={expenses}
            options={{
              headerStyle: {
                backgroundColor: "transparent",
                color: "#3f51b5",
                fontSize: "14px",
                fontWeight: 600,
              },
              rowStyle: {
                fontSize: "14px",
              },
              actionsColumnIndex: -1,
              pageSize: 10,
              pageSizeOptions: [5, 10, 20],
              searchFieldStyle: {
                borderRadius: 8,
                paddingLeft: 8,
              },
            }}
            actions={[
              (rowData) => ({
                icon: "delete",
                tooltip: "Eliminar Gasto",
                onClick: () => eliminarGasto(rowData.id),
              }),
            ]}
            components={{
              Action: (props) => (
                <Box display="flex" alignItems="center">
                  <Button
                    className={`${classes.actionButton} ${classes.actionButtonPdf}`}
                    size="small"
                    onClick={() => generarTicketCashOut(props.data.id)}
                  >
                    <Tooltip
                      title="Generar ticket de salida de efectivo"
                      aria-label="Generar ticket de salida de efectivo"
                    >
                      <PictureAsPdf style={{ color: "#f44336" }} />
                    </Tooltip>
                  </Button>
                  <Link
                    to={`/EditarGasto/${props.data.id}`}
                    style={{ textDecoration: "none" }}
                  >
                    <Button
                      className={`${classes.actionButton} ${classes.actionButtonEdit}`}
                      size="small"
                    >
                      <Tooltip title="Editar gasto" aria-label="Editar gasto">
                        <EditIcon style={{ color: "#3f51b5" }} />
                      </Tooltip>
                    </Button>
                  </Link>
                  <Button
                    className={`${classes.actionButton} ${classes.actionButtonDelete}`}
                    size="small"
                    onClick={() => eliminarGasto(props.data.id)}
                  >
                    <Tooltip title="Eliminar gasto" aria-label="Eliminar gasto">
                      <DeleteIcon style={{ color: "#f44336" }} />
                    </Tooltip>
                  </Button>
                </Box>
              ),
            }}
            localization={{
              pagination: {
                labelDisplayedRows: "{from} - {to} de {count}",
                labelRowsSelect: "Columnas",
                firstTooltip: "Primera Pagina",
                previousTooltip: "Anterior",
                nextTooltip: "Siguiente",
                lastTooltip: "Ultima Página",
              },
              toolbar: {
                searchTooltip: "Buscar",
                searchPlaceholder: "Buscar gastos...",
              },
              header: {
                actions: "Opciones",
              },
              body: {
                emptyDataSourceMessage: "No hay gastos registrados",
                filterRow: {
                  filterTooltip: "Buscar",
                },
              },
            }}
          />
        </Box>
      </Hidden>

      {/* Tabla de Gastos - Móvil */}
      <Hidden only={["md", "lg", "xl"]}>
        <Box className={classes.mobileTableContainer}>
          <MaterialTable
            title={"Gastos"}
            columns={[
              { title: "Nombre", field: "name" },
              {
                title: "Imagen",
                field: "image",
                render: (rowData) =>
                  rowData.image ? (
                    <ModalImage
                      small={rowData.image}
                      large={rowData.image}
                      alt="Ticket Gasto"
                    />
                  ) : (
                    <ModalImage
                      small={
                        "https://pisouniversitario.com/template/images/page-404.jpg"
                      }
                      large={
                        "https://pisouniversitario.com/template/images/page-404.jpg"
                      }
                      alt="Ticket Gasto"
                    />
                  ),
              },
            ]}
            data={expenses}
            options={{
              headerStyle: {
                backgroundColor: "transparent",
                color: "#3f51b5",
                fontSize: "14px",
                fontWeight: 600,
              },
              actionsColumnIndex: -1,
              pageSize: 5,
            }}
            detailPanel={[
              {
                tooltip: "Ver detalles",
                render: (rowData) => {
                  return (
                    <Box className={classes.detailPanel}>
                      <Box className={classes.detailItem}>
                        <strong>Descripción:</strong> {rowData.description}
                      </Box>
                      <Box className={classes.detailItem}>
                        <strong>Fecha/Hora:</strong> {rowData.created_at}
                      </Box>
                      <Box className={classes.detailItem}>
                        <strong>Total:</strong> ${rowData.total}
                      </Box>
                      <Box className={classes.detailItem}>
                        <strong>Sucursal:</strong> {rowData.branch_name}
                      </Box>
                      <Box className={classes.detailItem}>
                        <strong>Usuario:</strong> {rowData.username}
                      </Box>
                      <Box className={classes.detailActions}>
                        <IconButton
                          className={`${classes.actionButton} ${classes.actionButtonPdf}`}
                          size="small"
                          onClick={() => generarTicketCashOut(rowData.id)}
                        >
                          <Tooltip
                            title="Generar ticket"
                            aria-label="Generar ticket"
                          >
                            <PictureAsPdf style={{ color: "#f44336" }} />
                          </Tooltip>
                        </IconButton>
                        <Link to={`/EditarGasto/${rowData.id}`}>
                          <IconButton
                            className={`${classes.actionButton} ${classes.actionButtonEdit}`}
                            size="small"
                          >
                            <Tooltip
                              title="Editar gasto"
                              aria-label="Editar gasto"
                            >
                              <EditIcon style={{ color: "#3f51b5" }} />
                            </Tooltip>
                          </IconButton>
                        </Link>
                        <IconButton
                          className={`${classes.actionButton} ${classes.actionButtonDelete}`}
                          size="small"
                          onClick={() => eliminarGasto(rowData.id)}
                        >
                          <Tooltip
                            title="Eliminar gasto"
                            aria-label="Eliminar gasto"
                          >
                            <DeleteIcon style={{ color: "#f44336" }} />
                          </Tooltip>
                        </IconButton>
                      </Box>
                    </Box>
                  );
                },
              },
            ]}
            localization={{
              pagination: {
                labelDisplayedRows: "{from} - {to} de {count}",
                labelRowsSelect: "Columnas",
                firstTooltip: "Primera Pagina",
                previousTooltip: "Anterior",
                nextTooltip: "Siguiente",
                lastTooltip: "Ultima Página",
              },
              toolbar: {
                searchTooltip: "Buscar",
                searchPlaceholder: "Buscar",
              },
              header: {
                actions: "Opciones",
              },
              body: {
                emptyDataSourceMessage: "No hay gastos registrados",
                filterRow: {
                  filterTooltip: "Buscar",
                },
              },
            }}
          />
        </Box>
      </Hidden>

      {/* Divisor de sección para Comisiones */}
      <Box className={classes.sectionDivider}>
        <Chip
          label="Comisiones Pagadas"
          className={classes.sectionChip}
          icon={<AccountBalanceWalletIcon style={{ color: "#3f51b5" }} />}
        />
      </Box>

      {/* Tabla de Comisiones - Desktop */}
      <Hidden only={["xs", "sm"]}>
        <Box className={classes.tableContainer}>
          <MaterialTable
            title={"Comisiones Pagadas de la sucursal " + name}
            columns={[
              { title: "Vendedor", field: "seller" },
              { title: "Pagado Por", field: "username" },
              {
                title: "Total Pagado",
                field: "total",
                render: (rowData) =>
                  new Intl.NumberFormat("es-MX", {
                    style: "currency",
                    currency: "MXN",
                    minimumFractionDigits: 0,
                  }).format(rowData.total),
              },
            ]}
            data={comissions}
            options={{
              headerStyle: {
                backgroundColor: "transparent",
                color: "#3f51b5",
                fontSize: "14px",
                fontWeight: 600,
              },
              rowStyle: {
                fontSize: "14px",
              },
              actionsColumnIndex: -1,
              pageSize: 10,
              pageSizeOptions: [5, 10, 20],
            }}
            actions={[
              (rowData) => ({
                icon: "delete",
                tooltip: "Eliminar Gasto",
                onClick: () => eliminarGasto(rowData.id),
              }),
            ]}
            components={{
              Action: (props) => (
                <Box display="flex" alignItems="center">
                  <Button
                    className={`${classes.actionButton} ${classes.actionButtonIndigo}`}
                    size="small"
                    onClick={() =>
                      generarTicket(props.data.id, props.data.folio)
                    }
                  >
                    <Tooltip
                      title="Generar ticket de comisión"
                      aria-label="Generar ticket de comisión"
                    >
                      <PictureAsPdf style={{ color: "indigo" }} />
                    </Tooltip>
                  </Button>
                  <Button
                    className={`${classes.actionButton} ${classes.actionButtonDelete}`}
                    size="small"
                    onClick={() => eliminarGasto(props.data.id)}
                  >
                    <Tooltip title="Eliminar gasto" aria-label="Eliminar gasto">
                      <DeleteIcon style={{ color: "#f44336" }} />
                    </Tooltip>
                  </Button>
                </Box>
              ),
            }}
            localization={{
              pagination: {
                labelDisplayedRows: "{from} - {to} de {count}",
                labelRowsSelect: "Columnas",
                firstTooltip: "Primera Pagina",
                previousTooltip: "Anterior",
                nextTooltip: "Siguiente",
                lastTooltip: "Ultima Página",
              },
              toolbar: {
                searchTooltip: "Buscar",
                searchPlaceholder: "Buscar comisiones...",
              },
              header: {
                actions: "Opciones",
              },
              body: {
                emptyDataSourceMessage: "No hay comisiones registradas",
                filterRow: {
                  filterTooltip: "Buscar",
                },
              },
            }}
          />
        </Box>
      </Hidden>

      {/* Tabla de Comisiones - Móvil */}
      <Hidden only={["md", "lg", "xl"]}>
        <Box className={classes.mobileTableContainer}>
          <MaterialTable
            title={"Comisiones"}
            columns={[
              { title: "Vendedor", field: "seller" },
              { title: "Pagado Por", field: "username" },
            ]}
            data={comissions}
            options={{
              headerStyle: {
                backgroundColor: "transparent",
                color: "#3f51b5",
                fontSize: "14px",
                fontWeight: 600,
              },
              actionsColumnIndex: -1,
              pageSize: 5,
            }}
            detailPanel={[
              {
                tooltip: "Ver detalles",
                render: (rowData) => {
                  return (
                    <Box className={classes.detailPanel}>
                      <Box className={classes.detailItem}>
                        <strong>Total pagado:</strong> ${rowData.total}
                      </Box>
                      <Box className={classes.detailActions}>
                        <IconButton
                          className={`${classes.actionButton} ${classes.actionButtonIndigo}`}
                          size="small"
                          onClick={() =>
                            generarTicket(rowData.id, rowData.folio)
                          }
                        >
                          <Tooltip
                            title="Generar ticket de comisión"
                            aria-label="Generar ticket de comisión"
                          >
                            <PictureAsPdf style={{ color: "indigo" }} />
                          </Tooltip>
                        </IconButton>
                        <IconButton
                          className={`${classes.actionButton} ${classes.actionButtonDelete}`}
                          size="small"
                          onClick={() => eliminarGasto(rowData.id)}
                        >
                          <Tooltip
                            title="Eliminar gasto"
                            aria-label="Eliminar gasto"
                          >
                            <DeleteIcon style={{ color: "#f44336" }} />
                          </Tooltip>
                        </IconButton>
                      </Box>
                    </Box>
                  );
                },
              },
            ]}
            localization={{
              pagination: {
                labelDisplayedRows: "{from} - {to} de {count}",
                labelRowsSelect: "Columnas",
                firstTooltip: "Primera Pagina",
                previousTooltip: "Anterior",
                nextTooltip: "Siguiente",
                lastTooltip: "Ultima Página",
              },
              toolbar: {
                searchTooltip: "Buscar",
                searchPlaceholder: "Buscar",
              },
              header: {
                actions: "Opciones",
              },
              body: {
                emptyDataSourceMessage: "No hay comisiones registradas",
                filterRow: {
                  filterTooltip: "Buscar",
                },
              },
            }}
          />
        </Box>
      </Hidden>
    </LayoutDashboard>
  );
}
